import React from 'react'
import EnhancedTable from './PaymentsTable'
import '../Assets/styles/newStyles/Payments.css'

export const Payments = () => {
  const [totalAmount, setTotalAmount] = React.useState(0);
  const [assessmentCount, setAssessmentsCount]= React.useState(0)
  const [cashAmount, setCashAmount] = React.useState(0);
  const [onlineAmount, setOnlineAmount] = React.useState(0);

  const handlePayments=(total, assessmentCount, cashSum, onlineSum)=>{
    setTotalAmount(total)
    setAssessmentsCount(assessmentCount)
    setCashAmount(cashSum)
    setOnlineAmount(onlineSum)

  }

  const paymentCards= [{text:'Total Earnings', value:`${totalAmount}₹`, color:'black'},{text:'Earned Online',  value:`${onlineAmount}₹`, color:'#FCB514'},{text:'Earned by Cash',  value:`${cashAmount}₹`, color:'#82BF25'},{text:'Total Assessments', value:assessmentCount, color:'black'}]
    
  
  return (
    <div className='payments-main-container'>
    {localStorage.user==='admin'?  <div className="admin-header">
            <h1 className="admin-heading" style={{marginLeft:'18px'}}>Admin</h1>
            <div className="admin-stats">
              {/* <p className="admin-para">
                My Patients
                <span style={{ fontSize: "14px", marginLeft: "10px" }}>
                
                </span>{" "}
              </p> */}
            </div>
      </div>:<></>}
      <div className='payment-cards'>
      {paymentCards.map((each,index)=>
      <div className='payment-card' key={index}>
        <h3 className='payment-heading'>{each.text}</h3>
        <p className='payment-para' style={{color:each.color}}>{each.value}</p>
      </div>
      )}
      </div>
      <EnhancedTable handlePayments={handlePayments} />
    </div>
  )
  
}